import React from 'react';

interface FooterProps {}

const Footer: React.FC<FooterProps> = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              BRIGHT STONE CREDITS
            </h3>
            <p className="text-gray-300 mb-4 leading-relaxed">
              Kenya's leading financial institution providing fast, affordable, and reliable loans. 
              Registered under Companies Act, 2015 - Company Number 14682349.
            </p>
            <div className="flex items-center space-x-4">
              <div className="flex items-center">
                <i className="ri-shield-check-line text-green-400 mr-2"></i>
                <span className="text-sm">100% Legitimate</span>
              </div>
              <div className="flex items-center">
                <i className="ri-time-line text-blue-400 mr-2"></i>
                <span className="text-sm">10 Min Processing</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="/about" className="text-gray-300 hover:text-white transition-colors">About Us</a></li>
              <li><a href="/loans" className="text-gray-300 hover:text-white transition-colors">Explore Loans</a></li>
              <li><a href="/investments" className="text-gray-300 hover:text-white transition-colors">Investments</a></li>
              <li><a href="/contact" className="text-gray-300 hover:text-white transition-colors">Contact</a></li>
              <li>
                <a 
                  href="/admin/login" 
                  className="text-blue-400 hover:text-blue-300 transition-colors flex items-center"
                >
                  <i className="ri-shield-user-line mr-2"></i>
                  Agent Account
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Support</h4>
            <div className="space-y-3">
              <a
                href="https://wa.me/254740831354"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center text-gray-300 hover:text-white transition-colors"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                <span>+254740831354</span>
              </a>
            </div>
            <div className="mt-4 text-sm text-gray-400">
              <p>Available 24/7</p>
              <p>Kenya Support</p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 BRIGHT STONE CREDITS. All rights reserved. | Company No: 14682349
            </p>
            <div className="mt-4 md:mt-0">
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white text-sm transition-colors"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
